import { useEffect } from "react";

interface StructuredDataProps {
  id: string;
  data: Record<string, unknown>;
}

/**
 * Injects a JSON-LD (application/ld+json) structured data block into the
 * document head for the current page, and removes it once the page unmounts.
 */
export default function StructuredData({ id, data }: StructuredDataProps) {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, [id, data]);

  return null;
}